	// @Dependencies : jquery-form jquery-validate
	function form_submitter(){
		$('.jsfill').val('filled');
		
		// generic ajax form submission 
		// works with contact form 
		$('.btn-submit').on('click', function(e){
			e.preventDefault();
			
			var button = $(this);
			var form = button.closest('form');
			var hfields = form.find('.hiddenfields');
			var loader = form.find('.loader');
			// if the form isn't valid then stop here. 
			if(form.valid()){
	
				
				//button.text( button.data( 'sending-text' ) );
				//button.default_text = button.text();
		
				button.prop('disabled', 'diasbled');
				form.addClass('loading');
		
				$('<input/>', {
					'name'	: 'jsfilled',
					'value' : 'filled',
					'class' : 'off-screen'
				})
				.appendTo(hfields);
					
				form.ajaxSubmit({
					dataType : 'json',
					beforeSubmit : function(a, b, c){ },
					error: function() {
// 						console.log(response);
					},
					success : function(response){
// 						console.log(response.success);
						if(response.success){
							button.text(button.data('sent-text'))
							form.prop('disabled', 'disabled').hide();
							form.parent().html(response.response);
						}else{
							button.removeProp('disabled');
							form.after(response.response);
							button.text(button.default_text)
							console.log('err', response);
						}
					}
		
				})
			}
			return false;
		})
		
	}	
	
